import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { Container, Title, Text, GradientText } from "../Greeting/styles"

const Tabbi = () => (
  <Container>
    <motion.div
      initial="offscreen"
      animate="onscreen"
      variants={{
        offscreen: { opacity: 0, x: -50 },
        onscreen: { opacity: 1, x: 0 },
      }}
      transition={{ duration: 0.6 }}
      viewport={{ amount: 0.8 }}
    >
      <Title>FinTech Payments Platform</Title>
      <Text>
        As VP of Engineering at Tabbi, I own the full mobile application
        lifecycle for a React Native/Expo consumer app — from architecture and
        feature development to App Store releases. I architected a Turborepo
        monorepo spanning the mobile app, a React/Vite operator dashboard, and
        a serverless AWS backend using DynamoDB, GraphQL via AppSync, and
        Lambda. I designed a saga-based checkout pipeline integrating Toast POS,
        Spreedly, and Basis Theory for PCI-scoped payment processing, and led
        the migration from a Rails/PostgreSQL monolith to a fully serverless
        AWS stack.
      </Text>
      <Link className="link" to="https://www.tabbi.app/" target="_blank">
        <GradientText>Tabbi</GradientText>
      </Link>
      <div className="tech-icon-container">
        <div className="tech-icons">React Native</div>
        <div className="tech-icons">Expo</div>
        <div className="tech-icons">Typescript</div>
        <div className="tech-icons">Node.js</div>
        <div className="tech-icons">AWS</div>
        <div className="tech-icons">GraphQL</div>
        <div className="tech-icons">DynamoDB</div>
      </div>
    </motion.div>
  </Container>
)
export default Tabbi
